import axios from "axios";
import { isTokenExpired, getNewToken, getToken } from "helpers/auth";
import defaultHeaders from "./default-headers";

export const fetchAllFavoriteLists = async () => {
  if (isTokenExpired()) await getNewToken();
  const authorization = await getToken();
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v2/favorites/`;
  const response = await axios.get(url, {
    headers: {
      ...defaultHeaders,
      Authorization: authorization,
    },
  });
  return response.data;
};

export const createNewFavoriteList = async (title) => {
  if (isTokenExpired()) await getNewToken();
  const authorization = await getToken();
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v2/favorites/`;
  const response = await axios.post(
    url,
    { title },
    {
      headers: {
        ...defaultHeaders,
        Authorization: authorization,
      },
    }
  );
  return response.data;
};

export const removeFavoriteListing = async (listingId) => {
  if (isTokenExpired()) await getNewToken();
  const authorization = await getToken();
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v2/favorites/removeListing/${listingId}/`;
  const response = await axios.delete(url, {
    headers: {
      ...defaultHeaders,
      Authorization: authorization,
    },
  });
  return response.data;
};

export const addListingToFavoriteGroup = async (favoriteGroupId, listingId) => {
  if (isTokenExpired()) await getNewToken();
  const authorization = await getToken();
  const url = `${window.env.EJ_APPS_API_HOSTNAME}/e6t/v2/favorites/${favoriteGroupId}/addListing/${listingId}/`;
  const response = await axios.post(
    url,
    {},
    {
      headers: {
        ...defaultHeaders,
        Authorization: authorization,
      },
    }
  );
  return response.data;
};
